import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

export interface ExportDialogData {
  selectedCount: number;
}

export interface ExportDialogResult {
  format: 'csv' | 'excel';
}

@Component({
  selector: 'app-export-dialog',
  templateUrl: './export-dialog.component.html',
  styleUrls: ['./export-dialog.component.scss']
})
export class ExportDialogComponent {
  selectedFormat: 'csv' | 'excel' | null = null;
  maxExport = 2000;

  constructor(
      public dialogRef: MatDialogRef<ExportDialogComponent, ExportDialogResult>,
      @Inject(MAT_DIALOG_DATA) public data: ExportDialogData
  ) {}

  cancel(): void {
    this.dialogRef.close();
  }

  export(choice: 'excel' | 'csv'): void {
    if (choice === 'excel' && this.data.selectedCount > this.maxExport) {
      return;
    }
    this.selectedFormat = choice;
    this.dialogRef.close({ format: choice });
  }

}
